import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { injectHotkeyManagerService } from '@libs/shared/hotkey/hotkey-manager.service';
import { DatepickerDialogConfig } from '@libs/shared/ui/dialogs/datepicker-dialog/datepicker-dialog.type';
import { allAllowInElements } from '@libs/shared/utils/const/shortcut';

@Component({
  selector: 'app-datepicker-dialog',
  template: `
    <ng-container *ngLet="data">
      <h1 mat-dialog-title class="text-xl font-bold">{{ data.title }}</h1>
      <div mat-dialog-content>
        <form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
          <div class="w-100 flex flex-col items-center">
            <mat-form-field
              [floatLabel]="'always'"
              class="w-full"
              appearance="fill">
              <mat-label>{{ data.datepickerHeader }}</mat-label>
              <input
                matInput
                readonly
                (click)="picker.open()"
                [matDatepicker]="picker"
                formControlName="date" />
              <mat-datepicker-toggle matSuffix [for]="picker" />
              <mat-datepicker #picker />
            </mat-form-field>
          </div>
        </form>
      </div>
      <div mat-dialog-actions class="flex flex-row justify-end">
        <button mat-stroked-button (click)="onClose()">
          {{ data.actions.cancel.label }}
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="form.invalid"
          (click)="onSubmit()">
          {{ data.actions.confirm.label }}
        </button>
      </div>
    </ng-container>
  `,
  styles: [
    `
      .datepicker-dialog-panel {
        @screen md {
          @apply w-128;
        }

        .mat-mdc-dialog-container {
          padding: 0 !important;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatepickerDialogComponent implements AfterViewInit, OnDestroy {
  form: FormGroup;
  readonly hotkeyManager = injectHotkeyManagerService();

  constructor(
    private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DatepickerDialogConfig,
    public matDialogRef: MatDialogRef<DatepickerDialogComponent>
  ) {
    this._initForm();
  }

  ngAfterViewInit(): void {
    this.hotkeyManager.activateHotkeysForComponent(this.constructor.name, [
      {
        keys: 'meta.enter',
        description: '저장하기',
        allowIn: allAllowInElements,
        action: () => {
          this.onSubmit();
        },
      },
      {
        keys: 'escape',
        description: '닫기',
        allowIn: allAllowInElements,
        action: () => {
          this.onClose();
        },
      },
    ]);
  }

  ngOnDestroy(): void {
    this.hotkeyManager.deactivateHotkeys(this.constructor.name);
  }

  onSubmit() {
    if (this.form.valid) {
      this.matDialogRef.close(this.form.value.date);
    }
  }

  onClose() {
    this.matDialogRef.close('close');
  }

  _initForm() {
    this.form = this._fb.group({
      date: [new Date(), Validators.required],
    });
  }
}
